import React, { PropsWithChildren, useMemo } from "react";
import { useRestApiProvider } from "@jugl-web/rest-api";
import { useSelector } from "react-redux";
import { selectAuthState } from "@web-src/features/auth/authSlice";
import { skipToken } from "@reduxjs/toolkit/dist/query";
import {
  EntitySelectPageContext,
  EntitySelectPageContextValue,
} from "./EntitySelectPageContext";

export const EntitiesListProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { isAuthenticated } = useSelector(selectAuthState);
  const { entitiesApi } = useRestApiProvider();
  const {
    data: entities,
    isLoading: isEntitiesLoading,
    isFetching: isEntitiesFetching,
    isError: isEntitiesError,
    refetch: refetchEntities,
  } = entitiesApi.use_DEPRECATED_getAllOrgEntitiesListQuery(
    isAuthenticated ? undefined : skipToken
  );

  const {
    data: entityInvites,
    isLoading: isEntityInvitesLoading,
    isFetching: isEntityInvitesFetching,
    isError: isEntityInvitesError,
    refetch: refetchEntityInvites,
  } = entitiesApi.useGetEntityInvitesQuery(
    isAuthenticated ? undefined : skipToken
  );

  const value: EntitySelectPageContextValue = useMemo(
    () => ({
      entitiesState: {
        isLoading: isEntitiesLoading,
        isFetching: isEntitiesFetching,
        isError: isEntitiesError,
        entities,
      },
      entityInvitesState: {
        isLoading: isEntityInvitesLoading,
        isFetching: isEntityInvitesFetching,
        isError: isEntityInvitesError,
        entityInvites,
      },
      refetchEntities,
      refetchEntityInvites,
    }),
    [
      isEntitiesLoading,
      isEntitiesFetching,
      isEntitiesError,
      entities,
      isEntityInvitesLoading,
      isEntityInvitesFetching,
      isEntityInvitesError,
      entityInvites,
      refetchEntities,
      refetchEntityInvites,
    ]
  );

  return (
    <EntitySelectPageContext.Provider value={value}>
      {children}
    </EntitySelectPageContext.Provider>
  );
};
